import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "width", "height"]

import config from '@/config';

export default /*@__PURE__*/_defineComponent({
  __name: 'Logo',
  props: {
    width: { default: 100 },
    height: { default: 100 }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    id: "logo",
    src: _unref(config).LOGO_PATH,
    alt: "Aer",
    class: "logo",
    width: props.width,
    height: props.height
  }, null, 8, _hoisted_1))
}
}

})